import { fontName as fontName_1 } from './fontName.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import FontNamePicker from '../FontNamePicker';
import { RibbonButton, RibbonDropDownProps } from './RibbonButton';

import { setFontName } from 'roosterjs-editor-api';

const fontName: RibbonButton = {
    key: 'fontName',
    title: () => loc(fontName_1),
    imageSrc: require('../svg/fontname.svg'),
    createDropDownCallback: React.memo(
        ({ target, plugin, dismiss, logUsage }: RibbonDropDownProps) => {
            const onSelectName = React.useCallback(
                font => {
                    setFontName(plugin.getEditor(), font.family);
                    logUsage('setFontName', font.family);
                },
                [plugin]
            );
            return (
                <FontNamePicker
                    menuTargetElement={target}
                    onDismissMenu={dismiss}
                    onSelectName={onSelectName}
                    selectedName={plugin.getFormatState().fontName}
                />
            );
        }
    ),
};

export default fontName;
